export { default as ProductTab } from './src/products-tab';
export { default as ProductTabTxA } from './src/product-tab-transaction-account';
